import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { useGeoLocation } from 'hooks/useGeoLocation';

// Contexts
import { AuthContext } from '../contexts/AuthContext';

// Constants
import {
  getItemFromLocalStorage,
  redirectToCommonAuthLogin,
} from '../utils/common';

export const AuthProvider = ({ children }) => {
  const envObj = process.env;
  const [searchParams, setSearchParam] = useSearchParams();
  const [cfToken, setCfToken] = useLocalStorage('cfToken', null);

  // lat, long should be sent in all auth APIs, hence provide this data to all children
  const { latitude, longitude } = useGeoLocation();

  const cfTokenObj = {};
  let env;

  const populateCfToken = () => {
    try {
      const parsedCfToken = JSON.parse(getItemFromLocalStorage('cfToken'));
      if (parsedCfToken && typeof parsedCfToken === 'object') {
        Object.keys(parsedCfToken).forEach(key => {
          if (key === 'test' || key === 'prod')
            cfTokenObj[key] = parsedCfToken[key];
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  };
  const populateEnv = () => {
    env = searchParams.get('env') || 'prod';
  };

  populateCfToken();
  populateEnv();

  const switchEnv = () => {
    const currEnv = searchParams.get('env') || 'prod';
    switch (currEnv) {
      case 'prod':
        setSearchParam(new URLSearchParams(`?env=test`));
        populateEnv();
        break;
      case 'test':
        // Prod uses a clean URL — no env query param.
        setSearchParam(new URLSearchParams(''));
        populateEnv();
        break;
      default:
        break;
    }
  };

  // call this function when you want to authenticate the user
  const login = async (data, gammaToken) => {
    // sessionStorage.setItem('referrerUrl', window.location.href);
    if (gammaToken) cfTokenObj.test = gammaToken;
    else if (['gamma', 'beta', 'development'].includes(envObj.APP_ENV)) {
      cfTokenObj.test = data;
    }
    cfTokenObj.prod = data;
    setCfToken(cfTokenObj);
  };

  // call this function to sign out logged in user
  const logout = url => {
    setCfToken(null);
    if (url) window.location.assign(url);
    else redirectToCommonAuthLogin();
  };

  const value = useMemo(
    () => ({
      env,
      userObj: {
        cfToken: cfTokenObj,
        login,
        logout,
        populateCfToken,
        populateEnv,
        switchEnv,
      },
      latitude,
      longitude,
    }),
    [env, cfToken, latitude, longitude],
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.any,
};
